import { email as emailRegex } from '../utils/regex'
import { subscribe } from '../api/klaviyo'

class ResourceKlaviyoForm extends HTMLElement {
  constructor() {
    super()
    this.form = this.querySelector('.resource-form')
    this.emailInput = this.querySelector('input[name="email"]')
    this.name = this.querySelector('input[name="firstName"]')
    this.submit = this.querySelector('button')
    // this.emailError = this.querySelector('.resource-form-error')
    // this.listId = 'T94dAT'
    this.listId = this.form.dataset.resource
    this.submit.addEventListener('click', this.onSubmit)
  }

  destroy = () => {
    this.form.removeEventListener('click', this.onSubmit)
  }

  onSubmit = (event) => {
    event.preventDefault()
    // this.emailError.classList.add('hidden')

    if (!emailRegex.test(this.emailInput.value)) {
      console.log('the email is not valid')
      // this.emailError.classList.remove('hidden')
      setTimeout(() => {
        // this.emailError.classList.add('hidden')
      }, 3000)
      return
    }

    this.submit.classList.add('loading')

    subscribe(this.listId, this.emailInput.value, this.name.value)
      .then((response) => {
        console.log(response)
        this.submit.classList.remove('loading')
        // this.emailError.classList.add('hidden')
        // this.emailInput.value = "You're signed up!"
        this.emailInput.style.pointerEvents = "none";
        this.submit.innerHTML = "You're signed up!";
        this.submit.disabled = true;
        this.submit.style.pointerEvents = "none"
      })
      .catch((error) => {
        console.log(error)
        // this.emailError.classList.remove('hidden')
        this.emailInput.value = ''
        setTimeout(() => {
          // this.emailError.classList.add('hidden')
          this.emailInput.value = 'Enter your Email Address'
        }, 3000)
        alert('An error occured. Please try again later.')
        this.submit.classList.remove('loading')
      })
  }
}

customElements.define('resource-klaviyo-form', ResourceKlaviyoForm)
